export const LINEAGE_QUERY_OPTIONS = {
	staleTime: Infinity,
	cacheTime: Infinity,
	refetchOnMount: false,
	refetchOnWindowFocus: false,
	refetchOnReconnect: false,
};
